module.exports = __webpack_public_path__ + "img/avatar2.c967f0e0.png";